import { HatGlasses } from 'lucide-react'

import { Pill } from '~/components/component-library'
import { BackendTransaction } from '~/types'
import { parseTransactionMetadata } from '~/utils/parseTransactionMetadata'

/**
 * A series of transaction tags based on the provided transaction's properties (e.g. Private, Expired)
 *
 * @WARNING This component will return null if no features are applicable. `TransactionTitle` has been adapted to account for this, but other components should not use this component unless refactored.
 */
export const TransactionFeatureTags = ({
  transaction,
}: {
  transaction: BackendTransaction
}) => {
  const { swapData, bridgeData } =
    'transactionMetadata' in transaction
      ? parseTransactionMetadata(transaction.transactionMetadata)
      : {}
  const isPrivate = !!(swapData?.private ?? bridgeData?.private)

  if (!isPrivate) return null

  return (
    <div className="flex gap-1.5">
      {isPrivate && (
        <Pill
          size="small"
          label="Private"
          icon={() => <HatGlasses />}
          tooltipMessage="This transaction was sent privately"
        />
      )}
    </div>
  )
}
